import request from "@/utils/request";


// 每日标签打印数量变化
export const getCountByDay = function(query) {
  return request('get', '/api/statistics/tagPrintCountByDate', query)
}

// 标签补打记录占比
export const getPrintRecordProportion = function(query) {
  return request('get', '/api/statistics/tagPrintCount', query)
}

// 人员工作量
export const getUserWorkload = function(query) {
  return request('get', '/api/statistics/tagPrintUserWorkload', query)
}

// 打印器械包数量
export const getPackagePrintCount = function(query) {
  return request('get', '/api/statistics/tagPrintInstrumentset', query)
}

